import $api from "http/index";

const B = "dorm/";

export const listBuildings = () => $api.get(`${B}buildings/`);
export const createBuilding = (data) => $api.post(`${B}buildings/`, data);
export const updateBuilding = (id, data) => $api.patch(`${B}buildings/${id}/`, data);

export const listRooms = (params) => $api.get(`${B}rooms/`, { params });
export const createRoom = (data) => $api.post(`${B}rooms/`, data);
export const updateRoom = (id, data) => $api.patch(`${B}rooms/${id}/`, data);
export const deleteRoom = (id) => $api.delete(`${B}rooms/${id}/`);

export const listOccupancies = (params) => $api.get(`${B}occupancies/`, { params });
export const assignRoom = (data) => $api.post(`${B}occupancies/assign/`, data);
export const evictOccupancy = (id, data) => $api.post(`${B}occupancies/${id}/evict/`, data);

export const listDormPayments = (params) => $api.get(`${B}payments/`, { params });
export const registerDormPayment = (data) => $api.post(`${B}payments/register/`, data);

export const listIncidents = (params) => $api.get(`${B}incidents/`, { params });
export const createIncident = (data) => $api.post(`${B}incidents/`, data);
export const resolveIncident = (id, data) => $api.post(`${B}incidents/${id}/resolve/`, data);

export const ROOM_KINDS = {
  single: "Одноместная", double: "Двухместная", triple: "Трёхместная",
  quad: "Четырёхместная", family: "Семейная", block: "Блок",
};
